module.exports = __webpack_public_path__ + "static/media/arrowdown.224b3c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/arrowdown.png
// module id = 48
// module chunks = 0